// Layout — the persistent chrome around every page.
//
// Renders the top-bar / navbar above the page content and the footer below.
// The search modal lives here too because it should be available on every
// page regardless of route.

import TopBar from './TopBar';
import Navbar from './Navbar';
import Footer from './Footer';
import SearchModal from './SearchModal';

import type { WithChildren } from '../types';

export default function Layout({ children }: WithChildren) {
  return (
    <>
      <TopBar />
      <Navbar />
      {children}
      <Footer />

      {/* SearchModal mounts itself but only renders the actual modal when
          opened. Its trigger button lives in <Navbar>. They talk to each
          other via a module-level event emitter (see SearchModal.tsx). */}
      <SearchModal />
    </>
  );
}
